import type { FaireProductEntity } from "../../entity_types/product";

export const p_9mfrwqxsm8: FaireProductEntity = {
  token: "p_9mfrwqxsm8",
  type: "product",
  name: "Boho Ethnic Print Ruffled Sleeve V-Neck Dress",
  brandToken: "b_m4nc6munyv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/607bd9d0b60773b0c91e9dc426bd5a205beb20d2a50045e6df65f35f06fc16bd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aae1501790229d9ba2ead0c6235750c10a180dc23e8e44d64dd730fe48b1cf09.jpeg",
    "https://cdn.faire.com/fastly/7ae280799f1113b776cd3cb81be72161e9d678ba8c7234da3547325303a6abfc.jpeg",
    "https://cdn.faire.com/fastly/657e111a22a31c4e4caa5d03086eb3298dd6c828ea41ee44ea837191b1aeb797.jpeg",
    "https://cdn.faire.com/fastly/81422c94f56d5e6b7f44ec6570b073d54ee8557006e5777d8c657a3d608836c2.jpeg",
    "https://cdn.faire.com/fastly/83b812655be3a66da560d8704bab17fe64a35672a75778de9ffc7a8bf7dd6c4e.jpeg",
  ],
  priceDollars: 25.09,
  description:
    "BOHO ETHNIC PRINT RUFFLED SLEEVE V-NECK DRESS_RCJW05005\nPrint placement will vary for each individual garment.\n\nSize Chart(Inch)\t\t\t\n\tChest\tLength\tShoulder\nS\t 35.43 \t 54.72 \t 14.57 \nM\t 37.01 \t 55.12 \t 14.96 \nL\t 39.37 \t 55.51 \t 15.35 \nXL\t 41.73 \t 55.91 \t 15.75 \n\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2026 Women Apparel",
  tags: [],
  msrpDollars: 50.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:05.031Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
